export default "__VITE_ASSET__CrqgcUyg__"